export const InternshipsDurationRecord: Record<string, string> = {
  0: '< 1 mois',
  30: '1 mois',
  60: '2 mois',
  90: '3 mois',
  120: '4 mois',
  150: '5 mois',
  180: '6 mois',
  270: '> 6 mois',
};
